/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { Checkbox, Modal, Select } from "antd";
import { Info } from "lucide-react";
import { t } from "i18next";

interface DefaultProfileTypeModalProps {
  isOpen: boolean;
  onOk: () => void;
  onClose: () => void;
}

const PolicyConfirmModal: React.FC<DefaultProfileTypeModalProps> = ({
  isOpen,
  onOk,
  onClose,
}) => {
  return (
    <Modal
      title={
        <h2 className="text-xl font-semibold text-primary-blue mb-4 flex items-center gap-2">
          {t("payment_details.payment_policy")}
          <Info className="w-5 h-5 text-primary-blue" />
        </h2>
    }
    open={isOpen}
    onOk={onOk}
    okText={"I Agree"}
    closeIcon={null}
    cancelButtonProps={{
      style: { display: "none" },
    }}
    width={800}
    >
    {/* Payment Policy Section */}
      <div className="mt-8 col-span-1 md:col-span-2">
        <div className="space-y-4 text-justify">
          <p className="text-sm text-primary-blue leading-relaxed">
            {t("payment_details.payment_policy1")}
          </p>
          <p className="text-sm text-primary-blue leading-relaxed">
            {t("payment_details.payment_policy2")}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default PolicyConfirmModal;
